import { render } from "./CashFlowRelated.vue?vue&type=template&id=52e2d4d0&scoped=true"
import script from "./CashFlowRelated.vue?vue&type=script&lang=js"
export * from "./CashFlowRelated.vue?vue&type=script&lang=js"

import "./CashFlowRelated.vue?vue&type=style&index=0&id=52e2d4d0&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e2d4d0"]])

export default __exports__